<input [id]="field.key" type="text" [dpDayPicker]="config" (change)="onChange($event)" [mode]="'daytime'"
    [value]="(value ? (value | date:'dd.MM.yyyy hh:mm') : '')" autocomplete="off" />
